import { Component, Input, OnInit } from '@angular/core';
import { ResourceService } from '../../services/resource.service';

@Component({
  selector: 'app-building',
  templateUrl: './building.component.html',
  styleUrls: ['./building.component.scss']
})
export class BuildingComponent implements OnInit {

  public buildingClass;
  public costs = [];
  public affordable: boolean;

  public resourceService: ResourceService;


  constructor(resourceService: ResourceService) {
    this.resourceService = resourceService;
  }

  @Input()
  set tick(tick) {

  }

  @Input()
  set class(aClass: string) {
    this.buildingClass = aClass;
    this.setCosts(this.buildingClass.buildingCosts);
  }

  ngOnInit() {
  }

  public buy(event) {
    if (event.ctrlKey) {
      for (let i = 0; i < 4; i++) {
        if (this.buildingClass.resourceService.payResource(this.buildingClass.getBuildingCosts())) {
          this.buildingClass.addBuilding();
        }
      }
    }
    if (this.buildingClass.resourceService.payResource(this.buildingClass.getBuildingCosts())) {
      this.buildingClass.addBuilding();
    }
  }

  private setCosts(aCosts) {
    this.costs = [];
    Object.entries(aCosts).map(cost => {
      this.costs.push({
        resource: cost[0],
        amount: cost[1],
      });
    });
    this.canAfford();
  }

  private canAfford() {
    return this.buildingClass.resourceService.haveResource(this.buildingClass.buildingCosts);
  }

  public getBuildingImage() {
    return this.buildingClass.getBuildingImage();
  }

}
